import React, { useEffect, useRef, useState } from 'react';
import ProductIcon from '@material-ui/icons/Description';
import { productJsonProps } from '../../Constants/Products';
import classNames from 'classnames';
import ProductSearch from '../Product/ProductSearch';
import { get, isEmpty } from 'lodash';
import { Grid, Button } from '@material-ui/core/';

const ProductSearchElm = (props) => {
	const { asset, productName } = props;
	// handle product search element on value change.
	const productSearchOnValueChange = (selectedProductObj) => {
		// Only call if selectedProduct is not empty.
		if (!isEmpty(selectedProductObj)) {
			props.onValChange(selectedProductObj, asset);
		}
	};
	const onInputChange = (value) => {
		// un-stage the product, only when staged product is removed from product search autocomplete.
		// skip onChange event when no product is staged. i.e user enters text and remove it, not a valid product.
		if (value.length === 0 && !isEmpty(asset.product)) {
			props.onInputChange(asset);
		}
	};
	// product search components props
	const productSearchProps = {
		onValueChange: productSearchOnValueChange,
		onInputChange: onInputChange,
		inputValue: productName,
		id: asset.id,
	};
	return <ProductSearch {...productSearchProps} />;
};
// This component is a wrapper on top of Product Search.
// that provides product name link button when product is staged
// or product search autocomplete when there is no staged product.
const ProductSearchWrapper = (props) => {
	const { product, asset } = props;
	// check to if the asset.product is empty object.
	const hasProduct = Object.keys(product).length !== 0;
	const inputRef = useRef(null);
	const [openProductElm, setopenProductElm] = useState(false);
	// using display none class to toggle between product name link and product search autocomplete.
	// when asset has product, display a button with product name. when user click on the button open autocomplete search.
	// when asset has no product, directly display autocomplete search, so user can link a product.
	let hideProductElm = hasProduct;
	let hideProductLbl = !hasProduct;
	let productName = get(product, productJsonProps.name, '');
	if (openProductElm) {
		hideProductElm = false;
		hideProductLbl = true;
	}
	useEffect(() => {
		// setting focus on autocomplete search when product name button link is clicked.
		if (!hideProductElm && hasProduct) {
			inputRef.current.getElementsByTagName('input')[0].focus();
		}
	}, [hideProductElm, hasProduct]);
	const productElmClasses = classNames({
		displayNone: hideProductElm,
	});
	const productLblClasses = classNames({
		displayNone: hideProductLbl,
	});
	const productSearchElmProps = {
		asset,
		productName,
	};
	return (
		<Grid container>
			<Grid
				item
				xs={12}
				className={productElmClasses}
				ref={inputRef}
				key="product-search-div"
				onBlur={() => setopenProductElm(false)}
			>
				<ProductSearchElm {...props} {...productSearchElmProps} />
			</Grid>
			<Grid item xs={12} className={productLblClasses}>
				<Button
					startIcon={<ProductIcon />}
					onClick={() => setopenProductElm(true)}
					variant="outlined"
					color="primary"
					data-cy="staged-product-link"
				>
					{productName}
				</Button>
			</Grid>
		</Grid>
	);
};
export default ProductSearchWrapper;
